import Video from './Video'

class LineItem {
    constructor (content) {
        content.quantity = parseInt(content.quantity) || 1;
        _.extend(this, content);

        // done if no videos
        if (! content.videos || ! content.videos.length) {
            return;
        }

        var videos = [];

        this.videos.forEach(function createVideoInstance(video) {
            videos.push(new Video(video));
        }.bind(this))

        this.videos = videos;        
    }

    getInfo (info) {
        if (_.isUndefined(this.info)) return null;

        // compact <br> separated info for the item
        return _.reduce(this.info, function(result, info, key) {
            result += info.message + '<br>';
            return result;
        }, '')
    }

    getVideos () {
        if (! this.videos) return false
        return this.videos
    }

}

export default LineItem


// WEBPACK FOOTER //
// ./src/app/modules/Cart/classes/LineItem.js